import { get } from './utils';

export const getForm = async (formId: string) => await get<any>(`v1/form/${formId}`, true);
